angular
  .module('app')
  .component('colorNamingIndexComponent', {
    templateUrl: 'app/components/color-naming-index/color-naming-index.tmpl.html',
    controller: function ($location, anchorSmoothScroll) {
      const vm = this;
    }
  });
